
import React from "react";
import { Modal, Button, Row, Col, Card } from "react-bootstrap";
import { FaMicrophone, FaPaperPlane, FaUpload } from "react-icons/fa";

function NcReportModal_4({ show, handleClose }) {
    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
            <Modal.Body className="p-5">
                <strong className="fs-4">Nc Report</strong>
                {/* NC Info Card */}
                <Card className="mb-4 bg-light border-0 mt-4">
                    <Card.Body>
                        <Row>
                            <Col md={6}><strong>Product Name:</strong> MEP</Col>
                            <Col md={6}><strong>Product ID:</strong> <span className="text-dark ">Ru_90_46</span></Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={6}><strong>Qty NC:</strong> 50pcs</Col>
                            <Col md={6}><strong>Report Date:</strong> 12/03/2025</Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={6}><strong>Reported by:</strong> Suresh D (ID12)</Col>
                            <Col md={6}><strong>NC Type:</strong> Blowhole</Col>
                        </Row>
                        <div className="mt-3">
                            <Row>
                                <Col></Col>
                                <Col><Button variant="" className="btn bg-white" size="sm">Review NC Report</Button></Col>
                            </Row>
                        </div>
                    </Card.Body>
                </Card>

                <div className="border rounded p-3 mb-3 mt-4">
                    <div className="bg-secondary-subtle text-muted p-3 rounded mb-3 w-75">
                        Please describe the reason for NC report. You can provide details about what you're seeing, upload an image, or use voice input.
                    </div>
                    {/* Notes Input */}
                    <div className="border rounded p-2">
                        <div className="d-flex align-items-center">
                            {/* Left icons */}
                            <div className="d-flex gap-2">
                                <Button variant="light" className="border">
                                    <FaUpload />
                                </Button>
                                <Button variant="light" className="border">
                                    <FaMicrophone />
                                </Button>
                            </div>

                            {/* Textarea */}
                            <div className="flex-grow-1 mx-2">
                                <textarea
                                    className="form-control border-0 shadow-none"
                                    rows="1"
                                    placeholder="Type here..."
                                    style={{ resize: "none" }}

                                />
                            </div>

                            {/* Send Button */}
                            <div>
                                <Button variant="primary">
                                    <FaPaperPlane />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal.Body>
        </Modal>
    );
}

export default NcReportModal_4;
